import { useCallback } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Form } from "reactstrap";
import { Toggleable } from "../../../hook/useToggle";
import BusyButton from "../../common/busy-button";
import { AddIcon, CloseIcon } from "../../common/icons";
import AdditionalInfoPanel from "./additional-info-panel";
import AddressInfoPanel from "./address-info-panel";
import { useAddressState } from "./address-manager-context";
import './style.scss';
import useAddressApi from "./useAddressApi";
import confirm from "../../common/confirm";

const NewAddressModal = (props: Toggleable) => {
  const { isOpen, toggle } = props;

  const { form } = useAddressState();

  const { createAddress, busy } = useAddressApi();

  const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    createAddress(form)
      .then(ok => ok && toggle())
      .catch((e: Error) => confirm({
        title: 'Duplicated address',
        content: e.message,
        okText: '', // hide OK button
        cancelText: 'OK',
        titleCenter: true,
        bodyCenter: true
      }));
  }, [form]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg" scrollable autoFocus={false} >
      <ModalHeader toggle={toggle} tag={'h2'}>Create New Address</ModalHeader>
      <ModalBody>
        <Form id="new_address_form" className="oms-container" onSubmit={handleSubmit}>
          <fieldset className="oms-frame p-3">
            <legend>Address Information (Required Fields)</legend>
            <AddressInfoPanel autoFocus={true} />
          </fieldset>

          <fieldset className="oms-frame p-3">
            <legend>Additional Information</legend>
            <AdditionalInfoPanel />
          </fieldset>
        </Form>
      </ModalBody>
      <ModalFooter>
        <BusyButton form="new_address_form" type="submit"
          aria-label="Create" color="primary"
          value="Create" busy={busy}>
          <AddIcon />
        </BusyButton>

        <Button color="secondary" onClick={toggle} disabled={busy}>
          <CloseIcon /> Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default NewAddressModal;
